/**
 * 메인: 카테고리 목록
 *
 *
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { strCut, stringToMoneyFormat } from 'utils';
import { Content, Title, Button, ProductItem, Text } from 'components';
import { RightOutlined } from '@ant-design/icons';
import { useUserStack } from 'store';
import useGetShopProduct from 'hooks/custom/product/useGetShopProduct';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { encrypt } from 'utils/Crypto';
import { Empty } from 'antd';

/**----------------------------------------
 * [Component] 쇼핑몰 > 메인 > 브랜드 컴포넌트
 * ----------------------------------------
 */
const Brand = ({ brands = [], products = [], screenSize }) => {
  /* ===== INIT ===== */
  const navigate = useNavigate();
  /* ===== Store ===== */
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [tabs, setTabs] = useState([]);

  const [progress, setProgress] = useState(0);

  /* 스크롤 그라데이션 */
  const containerRef = React.useRef(null);
  const [hasScroll, setHasScroll] = useState(false);
  const [leftOpacity, setLeftOpacity] = useState(0); // 왼쪽 그라데이션 투명도
  const [rightOpacity, setRightOpacity] = useState(1); // 오른쪽 그라데이션 투명도
  const [selected, setSelected] = useState(tabs[0]);

  React.useEffect(() => {
    const currentContainer = containerRef.current;

    const checkScroll = () => {
      if (currentContainer) {
        const { scrollWidth, clientWidth, scrollLeft } = containerRef.current;

        const isScrollable = scrollWidth > clientWidth;
        setHasScroll(isScrollable);

        // 왼쪽 & 오른쪽 스크롤 여부 감지하여 opacity 조절
        setLeftOpacity(scrollLeft === 0 ? 0 : 1);
        setRightOpacity(scrollLeft + clientWidth >= scrollWidth ? 0 : 1);
      }
    };

    checkScroll(); // 최초 실행

    currentContainer?.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);

    return () => {
      currentContainer?.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', checkScroll);
    };
  }, [tabs, screenSize]);

  /**
   * 상품 목록 정제
   * --
   */

  // React.useMemo(() => {
  //   const newProductList = products?.filter((item) => );
  // }, [products, selected])

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 64 : screenSize >= 500 ? 30 : 26,
      lineHeight: screenSize >= 768 ? '88px' : '150%',
      marginBottom: screenSize >= 500 ? 0 : 20,
      paddingRight: 10,
    },
    subTitle: {
      fontSize: 18,
      fontWeight: 400,
      lineHeight: '30px',
      color: 'var(--black-color)',
    },

    mainFlexContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },

    bullet: {
      width: 12,
      height: 12,
      borderRadius: '50%',
      border: '3px solid var(--black-color)',
      display: 'inline-block',
      marginRight: 12,
      cursor: 'pointer',
    },
  };

  /* ===== FUNCTION ===== */

  /* ===== HOOKS ===== */
  /**
   * 브랜드별 탭
   * --
   */
  React.useEffect(() => {
    if (!brands?.length || !products?.length) return;
    const trueBrands = brands.filter((item) => item.is_brand === 'Y');
    const divTrueBrands = trueBrands.reduce(
      (acc, cur) => {
        const { shop_information_id, shop_information_name } = cur;
        if (!acc.shopName[shop_information_id]) {
          acc.shopName[shop_information_id] = shop_information_name;
        }
        acc.brands?.push(cur);
        return acc;
      },
      { brands: [], shopName: {} }
    );
    const categoryList = Object.entries(divTrueBrands?.shopName).map(
      ([shop_information_id, shop_information_name]) => ({
        value: shop_information_id,
        label: shop_information_name,
      })
    );
    setTabs(categoryList);
  }, [brands, products]);

  /* ===== RENDER ===== */
  React.useEffect(() => {
    if (!tabs.length) return;
    setSelected(tabs?.[0]?.value);
  }, [tabs]);
  // JSX: start

  return (
    <div>
      <Content
        maxWidth={1500}
        padding={screenSize >= 768 ? 40 : 20}
        style={{
          marginTop: screenSize >= 768 ? 100 : 0,
          margin: '0 auto',
        }}
        backgroundColor="#F8F8F8"
        className="bestsellers main_swiper"
      >
        <Title
          style={{ ...styles.title, flexWrap: 'wrap' }}
          className="dela-gothic"
          subButton={
            <Button
              onClick={() => navigate(`/brand`)}
              style={{
                fontSize: screenSize >= 768 ? 16 : 13,
                padding: screenSize >= 768 ? '8px 30px' : '4px 10px',
                minWidth: 82,
              }}
              className={'goto'}
            >
              바로가기 <RightOutlined />
            </Button>
          }
        >
          Brands
        </Title>
        {/* ===== 탭 ===== */}
        <div
          className="button_wrap"
          style={{
            position: 'relative',
          }}
        >
          {/* 좌측 그라데이션 */}
          {hasScroll && (
            <div
              style={{
                position: 'absolute',
                width: 25,
                height: '100%',
                top: 0,
                left: 0,
                background:
                  'linear-gradient(to right, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%)',
                zIndex: 3,
                opacity: leftOpacity,
                transition: 'opacity 0.3s ease-in-out',
                pointerEvents: 'none',
              }}
            />
          )}
          <div
            ref={containerRef}
            style={{
              width: '100%',
              overflowX: 'auto',
              display: 'flex',
              flexDirection: 'row',
              gap: screenSize >= 768 ? 20 : 10,
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {tabs.map((tab) => (
              <Button
                key={tab.value}
                className={selected === tab.value ? '' : 'unsellected'}
                onClick={() => setSelected(tab.value)}
              >
                {tab.label}
              </Button>
            ))}
          </div>
          {/* 우측 그라데이션 */}
          {hasScroll && (
            <div
              style={{
                position: 'absolute',
                width: 25,
                height: '100%',
                top: 0,
                right: 0,
                background:
                  'linear-gradient(to left, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%)',
                zIndex: 3,
                opacity: rightOpacity,
                transition: 'opacity 0.3s ease-in-out',
                pointerEvents: 'none',
              }}
            />
          )}
        </div>
        <Swiper
          slidesPerView={screenSize >= 1000 ? 4 : screenSize >= 700 ? 3 : 2}
          spaceBetween={screenSize >= 1000 ? 20 : 15}
          modules={[Navigation]}
          loop={false}
          navigation
          onSlideChange={(swiper) => {
            if (swiper.activeIndex === 0) setProgress(0);
            const totalSlides = swiper.slides.length;
            const visibleSlides = swiper.params.slidesPerView;
            const currentProgress =
              (swiper.activeIndex + visibleSlides) / totalSlides;
            const maxProgress =
              totalSlides <= visibleSlides
                ? 100
                : Math.max(0, currentProgress * 100);
            setProgress(Math.min(100, maxProgress));
          }}
          style={{
            minHeight:
              screenSize >= 1600 ? 690 : screenSize >= 400 ? '40vw' : '95vw',
          }}
        >
          {products.filter((item) => item.shopKey === Number(selected)).length >
          0 ? (
            products
              .filter((item) => item.shopKey === Number(selected))
              .map((_item, _index) => (
                <SwiperSlide key={`product_${_index}`}>
                  <div
                    onClick={() =>
                      navigate(
                        `/products/${encodeURIComponent(encrypt(_item.key))}`
                      )
                    }
                  >
                    <ProductItem
                      src={_item.src}
                      title={_item.title}
                      price={_item.price}
                      discount={_item.discount}
                      discountType={_item.discount_type}
                      // review={_item.review_count}
                      // tags={_item.tag}
                      hovered={false}
                      brand={null}
                      titleStyle={{ marginTop: 10 }}
                      isSoldOut={_item.isSoldOut === 'Y' ? true : false}
                      policies={_item.policies}
                      icons={[
                        {
                          label: 'BEST',
                          color: 'rgb(202, 97, 98)',
                        },
                        ...(_item.isNew === 'Y'
                          ? [
                              {
                                label: 'NEW',
                                color: 'rgb(56, 56, 56)',
                              },
                            ]
                          : []),
                      ]}
                    />
                    <ProductItem.Review
                      review={{ score: _item.score, comment: _item.comment }}
                      style={{ marginTop: 16 }}
                    />
                    <ProductItem.Tags
                      tags={_item.tags.map((tag) => ({
                        id: tag.tag_id,
                        label: tag.label,
                      }))}
                      style={{ marginBottom: 4 }}
                    />
                  </div>
                </SwiperSlide>
              ))
          ) : (
            <div
              style={{
                width: '100%',
                height: 500,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Empty description={<Text size={18}>상품이 없습니다.</Text>} />
            </div>
          )}
        </Swiper>
        <div
          style={{
            width: '100%',
            height: '7px',
            backgroundColor: '#ddd',
            borderRadius: 15,
            marginBottom: screenSize >= 1800 ? 20 : 30,
          }}
        >
          <div
            style={{
              width: `${progress}%`,
              height: '100%',
              backgroundColor: 'var(--black-color)',
              transition: 'width 0.3s ease-in-out',
              borderRadius: 15,
            }}
          />
        </div>
      </Content>
    </div>
  ); // JSX: end
};

export default Brand;
